/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]   .module-opener-button[_ngcontent-%COMP%]{width:100%;height:40px;background:#87a5ec;color:#fff;font-size:24px}"];
export { styles as styles };
